import type { CalendarSurfaceStore } from 'owa-calendar-surface-dategrid';
import { action } from 'satcheljs/lib/legacy';
import { updateSelectedItem } from './updateSelectedItem';

/**
 * Called to clear the currently selected item on surface.
 * @store The surface store
 * @customSelector - If we have to select an item that does not follow the regular norm of CSSSelector,
 * one can pass a custom selector. For instance, agenda peek uses this to select calendar items on it.
 */
export let clearSelectedItem = action('clearSelectedItem')(function clearSelectedItem(
    store: CalendarSurfaceStore,
    customSelector: string = null
) {
    updateSelectedItem(null, null, store, customSelector);
});
